/**
 * « Équipe type du tournoi » : les meilleurs notés par poste, disposés en 4-3-3
 * sur un terrain (rendu HTML, pas SVG → photos + chips + drapeaux + survol faciles).
 * Rendu PUR. Chaque joueur porte `data-player`/`data-name` → fiche au survol.
 */
import type { LeaderRow, TournamentXI } from "../../app/leaderboards.ts";
import { esc, flagCode } from "../html.ts";
import { t } from "../../app/i18n.ts";

const rateCls = (r: number): string => (r >= 7.5 ? "hi" : r >= 6.5 ? "mid" : "lo");

/** Nom court pour la pastille (dernier mot = nom de famille en général). */
function surname(name: string | null): string {
  if (!name) return "—";
  const parts = name.trim().split(/\s+/);
  return parts[parts.length - 1] || name;
}

function playerNode(r: LeaderRow): string {
  const name = r.name ?? "—";
  const photo = r.photo
    ? `<img class="xi-photo" src="${esc(r.photo)}" alt="" loading="lazy" referrerpolicy="no-referrer">`
    : `<span class="xi-photo xi-photo-ph"><i class="ti ti-user" aria-hidden="true"></i></span>`;
  const rate = r.rating != null ? `<span class="xi-rate ${rateCls(r.rating)}">${r.rating.toFixed(1)}</span>` : "";
  const flag = r.teamCode ? `<span class="f fi fi-${esc(flagCode(r.teamCode))} xi-flag"></span>` : "";
  const tag = Number.isInteger(r.id) ? ` data-player="${r.id}" data-name="${esc(name)}" tabindex="0"` : "";
  return `<div class="xi-player"${tag}>
    <span class="xi-av">${photo}${rate}</span>
    <span class="xi-name">${flag}<span>${esc(surname(name))}</span></span>
  </div>`;
}

function line(list: readonly LeaderRow[], cls: string): string {
  if (!list.length) return "";
  return `<div class="xi-line ${cls}">${list.map(playerNode).join("")}</div>`;
}

/** Carte « Équipe type ». Chaîne vide si aucun joueur (section appelante masque). */
export function tournamentXiHtml(xi: TournamentXI): string {
  const total = xi.gk.length + xi.def.length + xi.mid.length + xi.fwd.length;
  if (total === 0) return "";
  return `<div class="card xi-card">
    <div class="xi-head"><i class="ti ti-soccer-field" aria-hidden="true"></i><span>${t("fiche.tournamentXi")}</span><span class="xi-formation">${esc(xi.formation)}</span></div>
    <div class="xi-pitch">
      ${line(xi.fwd, "xi-fwd")}
      ${line(xi.mid, "xi-mid")}
      ${line(xi.def, "xi-def")}
      ${line(xi.gk, "xi-gk")}
    </div>
  </div>`;
}
